module.exports = __webpack_public_path__ + "static/media/none.d3d80f6f.jpg";